import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { useStore } from '@stores/RootStore';
import { DepthIcon } from '@icons/DepthIcon';
import { SubscriptionIcon } from '@icons/index';
import { withLogin } from '@hoc/withLogin';
import { Lnb } from '../../common/lnb';

// 구독 관리자에게 허용된 서브메뉴
// TODO: MZP2-5714 - 라우터 레벨에서 접근 제어 추가 검토 필요
const SUBSCRIPTION_OWNER_ALLOWED_SUBMENUS = ['list', 'user-mgmt'];

export const Subscription: React.FC = withLogin(
  observer(() => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { authStore } = useStore();

    // Manager.tsx에서 isInitialized 가드 담당
    const isSubscriptionOwnerOnly = authStore.isSubscriptionOwnerOnly;

    const allSubMenus = useMemo(
      () => [
        {
          name: t('Subscription.menu.list'),
          icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
          selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
          to: 'list',
        },
        {
          name: t('Subscription.menu.user'),
          icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
          selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
          to: 'user-mgmt',
        },
        {
          name: t('Subscription.menu.connection'),
          icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
          selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
          to: 'connections',
        },
        {
          name: t('Subscription.menu.accessRequest'),
          icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
          selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
          to: 'usage-registers',
        },
        {
          name: t('Subscription.menu.technicalSupport'),
          icon: <DepthIcon width={16} height={16} color={theme.colors['ic-gray-main']} />,
          selectedIcon: <DepthIcon width={16} height={16} color={theme.colors['ic-primary-light']} />,
          to: 'technical-support',
        },
      ],
      [t, theme.colors],
    );

    // 구독 관리자 전용인 경우 허용된 메뉴만 표시
    const filteredSubMenus = useMemo(
      () =>
        isSubscriptionOwnerOnly
          ? allSubMenus.filter(menu => SUBSCRIPTION_OWNER_ALLOWED_SUBMENUS.includes(menu.to))
          : allSubMenus,
      [allSubMenus, isSubscriptionOwnerOnly],
    );

    return (
      <Container>
        <Lnb
          menuItem={[
            {
              name: t('Subscription.menu.title'),
              icon: <SubscriptionIcon width={20} height={20} color={theme.colors['ic-gray-main']} />,
              subMenu: filteredSubMenus,
            },
          ]}
        />
        <Outlet />
      </Container>
    );
  }),
);

const Container = styled('div')`
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: flex;
`;
